import { createFileRoute } from '@tanstack/react-router'

import { ImagePipelineSettings } from '@/components/Internal/System/ImagePipelineSettings'

export const Route = createFileRoute('/internal/system/settings/images')({
  component: ImagePipelineSettings,
})
